import { NgModule } from "@angular/core";
import { LoginComponent } from "./login.component";
import { AdminCommonModule } from "../admin/admin-common.module";

@NgModule({
    declarations: [
        LoginComponent
    ],
    imports: [
        AdminCommonModule
    ]
})
export class LoginModule {
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/account/login.module.ts